/**
 * @function dispatchCurrentKey
 *
 * Dispatches the current key based on scroll to vuex store.
 *
 */

export default function () {
    const scrollDistance = window.pageYOffset
    const containerRectTop = this.$el.getBoundingClientRect().top
    const containerFromTop = scrollDistance + containerRectTop
    const trayHeight = this.$el.querySelector('.js-stickyTray').scrollHeight
    const triggerValue = scrollDistance - containerFromTop

    if (
        triggerValue < trayHeight &&
        this.currentKey !== 'one'
    ) {
        this.$store.dispatch('setCurrentKey', 'one')
    } else if (
        triggerValue > trayHeight &&
        triggerValue < trayHeight * 2 &&
        this.currentKey !== 'two'
    ) {
        this.$store.dispatch('setCurrentKey', 'two')
    } else if (
        triggerValue > trayHeight * 2 &&
        triggerValue < trayHeight * 3 &&
        this.currentKey !== 'three'
    ) {
        this.$store.dispatch('setCurrentKey', 'three')
    } else if (
        triggerValue > trayHeight * 3 &&
        triggerValue < trayHeight * 4 &&
        this.currentKey !== 'four'
    ) {
        this.$store.dispatch('setCurrentKey', 'four')
    } else if (
        triggerValue > trayHeight * 4 &&
        this.currentKey !== 'five'
    ) {
        this.$store.dispatch('setCurrentKey', 'five')
    }
}
